import { useEffect } from 'react';
import { collection, doc, getDocsFromServer, limit, query, runTransaction } from 'firebase/firestore';
import { db } from '../../firebase/config';

export const DEFAULT_DOC_ID = 'default';
export const OFFLINE_MESSAGE = 'Sei offline: riprova quando torna la connessione.';

// Crea users/{uid}/{name}/default solo se la collezione è vuota sul server.
// Mai ID casuali: l'app legge categoriesData[0], un documento in più cambierebbe quello mostrato (#100).
export async function ensureDefaultDoc(uid, name, seed) {
  const col = collection(db, 'users', uid, name);
  // offline rifiuta: niente scritture alla cieca
  const existing = await getDocsFromServer(query(col, limit(1))).catch((e) => {
    throw e?.code === 'unavailable' ? new Error(OFFLINE_MESSAGE) : e;
  });
  if (!existing.empty) return false;
  const ref = doc(col, DEFAULT_DOC_ID);
  return runTransaction(db, async (tx) => {
    if ((await tx.get(ref)).exists()) return false; // un'altra scheda l'ha già creato
    const now = new Date().toISOString();
    tx.set(ref, { ...seed, createdAt: now, updatedAt: now });
    return true;
  });
}

// Crea i documenti iniziali (categorie, negozi) per un utente nuovo.
// categoriesData è [] anche prima del primo snapshot: decide il server, non lo stato locale.
export function useSeedUserDocs({ user, categoriesData, storesData, defaultCategories }) {
  const uid = user?.uid;
  const noCategories = categoriesData.length === 0;
  const noStores = storesData.length === 0;

  useEffect(() => {
    if (!uid) return;
    if (noCategories) {
      ensureDefaultDoc(uid, 'categories', defaultCategories).catch((e) =>
        console.error('Creazione categorie iniziali non riuscita:', e)
      );
    }
    if (noStores) {
      ensureDefaultDoc(uid, 'stores', { stores: [] }).catch((e) =>
        console.error('Creazione negozi iniziali non riuscita:', e)
      );
    }
  }, [uid, noCategories, noStores, defaultCategories]);
}
